<script>
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from "vue-router";
//component
import MainPage from '../component/Layout/MainPage.vue'
import CampaignList from '../component/CampaignList/CampaignList.vue'
//model
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
//feature
import { useLandingFlow } from '../feature/LandingFlowFeature'
// core
import BzbsApiLegacy from '@/core/Http/BzbsApiLegacy';
// helper
// import Utility from '@/helper/Utility';
// import { useLocale } from '../feature/LocaleFeature';


export default defineComponent({
    components: {
        MainPage,
        CampaignList
    },
    setup() {
        const { query,profile } = useLandingFlow()
        const route = useRoute()
        const router = useRouter()
        let elemCampaingList = ref(null)
        let listConfig = ref(null)
        let filterConfig = ref(null)
        let title = ref()
        let description = ref("")
        let header = ref("")

        const init = () => {
            console.log("query", query.value)
            console.log("profile", profile.value)
        }

        const onUpdateCate = (data) => {
            title.value = data + ' Store'
        }

        const initialConfig = () => {
            var configStr = 'campaign_shopcode_topup';
            var listConfigBuilder = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setTop(25)
                .setCatId(route.params.categoryId)
                .create();
            listConfig.value = listConfigBuilder
            var filterConfigBuilder = new CampaignListFilterConfigBuilder().create();
            filterConfig.value = filterConfigBuilder;
        }

        const initialConfigDescription = () => {
            let blobPath = 'config/weblanding/api2c2p/description.json'
            return new Promise((resolve, reject) => {
                BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blobPath).then((res_config) => {
                    res_config.list.forEach((item) => {
                        if(item.cate_id == route.params.categoryId){
                            description.value = item.description
                            header.value = item.header
                        }
                    })
                    resolve(true)
                }).catch((err) => {
                    console.log(err)
                    reject(err)
                });
            })
        }

        const setScrollLoadMore = () => {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    loadMore();
                }
            };
        }

        const onLoadSuccess = (api) => {
            console.log("onLoadSuccess", api)
            //modal.loadingModal.hide();
        }

        const loadMore = () => {
            if(listConfig.value && filterConfig.value){
                elemCampaingList.value.loadMore();
            }
        }

        onMounted(() => {
            //modal.loadingModal.show();
        })
        onBeforeUnmount(() => {
            window.onscroll = null;
        })

        const onClickBack = () => {
            router.replace('/topup2c2p/home')
        }

        init()
        //#region init
        setScrollLoadMore()
        initialConfig()
        initialConfigDescription()
        //#endregion init
        return {
            listConfig,
            filterConfig,
            elemCampaingList,
            onLoadSuccess,
            onClickBack,
            title,
            header,
            description,
            onUpdateCate
        }
    },
});
</script>
<template>
    <MainPage :title=title @clickBack="onClickBack()">
        <div class="mt-4">
            <CampaignList
                    ref="elemCampaingList"
                    :header="header"
                    :initListConfig="listConfig"
                    :initFilterConfig="filterConfig"
                    @onLoaded="onLoadSuccess('campaign')"
                    @onUpdateCate="onUpdateCate($event)"
            ></CampaignList>
        </div>
        <div class="bg-white px-5 mt-4 py-2" v-if="description !== ''" v-html="description"></div>
        
    </MainPage>
</template>
<style lang="scss" scoped>
</style>
